// extracted by mini-css-extract-plugin
module.exports = {"content":"Eulogy_content__cpHqo","gridItem":"Eulogy_gridItem__112Ju","img":"Eulogy_img__2-gUr","card":"Eulogy_card__4S9FN","text":"Eulogy_text__7sW-e"};